export const BOOTSTRAP_SUCCESS = 'BOOTSTRAP_SUCCESS';
export const INIT_REQUEST = 'INIT_REQUEST';
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const INIT_INVALID_DEAL_SUCCESS = 'INIT_INVALID_DEAL_SUCCESS';
export const INIT_FAILURE = 'INIT_FAILURE';
export const INIT_PENCIL_SUCCESS = 'INIT_PENCIL_SUCCESS';
export const INIT_PENCIL_INVALID_DEAL = 'INIT_PENCIL_INVALID_DEAL';
/**
 * Signals that the browser tab title should be recomputed from current state. The bootstrap
 * middleware only applies `getDocumentTitle` on INIT_SUCCESS, which MV synthesizes in dash-store's
 * offerMiddleware; apps that never dispatch INIT_SUCCESS (e.g. Sales Check-In) dispatch this
 * instead — after the actions carrying customer/buyer data — so the title also survives changes
 * made past the initial load.
 */
export const UPDATE_DOCUMENT_TITLE = 'UPDATE_DOCUMENT_TITLE';
export const TURN_OFF_DEAL_TEMPLATES_VIEW = 'TURN_OFF_DEAL_TEMPLATES_VIEW';
export const TURN_ON_DEAL_TEMPLATES_VIEW = 'TURN_ON_DEAL_TEMPLATES_VIEW';
export const GET_DETAILS_SUCCESS = 'GET_DETAILS_SUCCESS';
